<template>
  <div class="container">
    <div>
      <el-form inline>
        <el-form-item :label="$t('Operator')" v-show="zong">
          <el-select v-model="filters.SellerId" @change="changeSellerId" :placeholder="$t('Operator')" style="width: 150px">
            <el-option v-for="item in seller" :key="item.SellerId" :label="item.SellerName" :value="item.SellerId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-form-item :label="$t('transactionCurrency')">
            <el-input style="width: 150px" :placeholder="$t('transactionCurrency')" v-model="queryForm.Symbol" clearable> </el-input>
          </el-form-item>
          <el-form-item :label="$t('Status')">
            <el-select style="width: 150px" v-model="queryForm.State" :placeholder="$t('PleaseSelect')" clearable>
              <el-option :label="$t('Enable')" :value="1"></el-option>
              <el-option :label="$t('deactivate')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CurrencyCategory')">
            <el-select style="width: 150px" v-model="queryForm.FType" :placeholder="$t('PleaseSelect')" clearable>
              <el-option :label="$t('FiatCurrency')" :value="1"></el-option>
              <el-option :label="$t('cryptocurrency')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="getSymbolList">{{$t('Search')}}</el-button>
          <!-- <el-button type="primary" @click="showBaseExchange">{{ $t('BaseExchangeRateConfiguration') }}</el-button>
          <el-button type="primary" @click="showChangeHistory">{{ $t('ExchangeRateChangeRecord') }}</el-button> -->
          <el-button type="primary" @click="batchState">{{ $t('BulkEditStatus') }}</el-button>
          <!-- <el-button type="primary" @click="batchRate">{{ $t('BatchEditAutomaticExchangeRate') }}</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45"> </el-table-column>
      <el-table-column prop="Id" label="ID" width="50px"></el-table-column>
      <el-table-column prop="Sort" :label="$t('Sorting')" width="80"></el-table-column>
      <el-table-column align="center" :label="$t('Operator')" width="80" v-if="zong" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ seller.find((item) => item.SellerId == scope.row.SellerId)?.SellerName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="PSymbol" :label="$t('PlatformCurrency')" width="80" ></el-table-column>
      <el-table-column prop="Symbol" :label="$t('transactionCurrency')"></el-table-column>
      <el-table-column prop="RateSource" :label="$t('exchangeRateSource')">
        <template slot-scope="scope">
          <span v-if="scope.row.RateSource == 1">{{$t('binance')}}</span>
        </template>
      </el-table-column>
      <el-table-column width="125px" prop="RechargeFix">
        <template slot="header">
          <el-tooltip effect="dark" placement="top">
            <div slot="content" style="text-align: center">充值的话，为交易币种→平台币种，而交易的汇率是 平台币种:交易币种，<br />所以充值交易的汇率 = 即时汇率 + 偏差值</div>
            <div style="display: inline-block">
              <span style="margin-right: 5px">{{ $t('depositExchangeRateDiscrepancy') }}</span>
              <span class="el-icon-question"></span>
            </div>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.RechargeFixType == 1">{{ scope.row.RechargeFix }}</span>
          <span v-else>{{ Math.round(scope.row.RechargeFix * 10000000) / 100000 }}%</span>
        </template>
      </el-table-column>
      <el-table-column width="120px" prop="RechargeFixType" :label="$t('RechargeRateDeviationRules')">
        <template slot-scope="scope">
          <span v-if="scope.row.RechargeFixType == 1">{{ $t('Eigenvalue') }}</span>
          <span v-else>{{ $t('percentage') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="WithwardFix" width="125px" :label="$t('withdrawalExchangeRateDeviation')">
        <template slot="header">
          <el-tooltip effect="dark" placement="top">
            <div slot="content" style="text-align: center">提款的话，为平台币种→交易币种，而交易的汇率是 平台币种:交易币种，<br />所以提款交易的汇率 = 即时汇率 - 偏差值</div>
            <div style="display: inline-block">
              <span style="margin-right: 5px">{{ $t('withdrawalExchangeRateDifferential') }}</span>
              <span class="el-icon-question"></span>
            </div>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.WithwardFixType == 1">{{ scope.row.WithwardFix }}</span>
          <span v-else>{{ Math.round(scope.row.WithwardFix * 10000000) / 100000 }}%</span>
        </template>
      </el-table-column>
      <el-table-column width="120px" prop="WithwardFixType" :label="$t('WithdrawalRateDeviationRules')">
        <template slot-scope="scope">
          <span v-if="scope.row.WithwardFixType == 1">{{ $t('Eigenvalue') }}</span>
          <span v-else>{{ $t('percentage') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('depositRange')">
        <template slot-scope="scope">
          <span v-if="scope.row.FType == 1"> --</span>
          <span v-else>{{ scope.row.RechargeMin }}-{{ scope.row.RechargeMax }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('withdrawalRange')">
        <template slot-scope="scope">
          <span v-if="scope.row.FType == 1"> --</span>
          <span v-else>{{ scope.row.WithwardMin }}-{{ scope.row.WithwardMax }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="RechargeRate" :label="$t('depositExchangeRaten')">
        <template slot-scope="scope">
          <span v-if="scope.row.AutoState == 1">{{ scope.row.RechargeRate }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="WithwardRate" :label="$t('withdrawalExchangeR')">
        <template slot-scope="scope">
          <span v-if="scope.row.AutoState == 1">{{ scope.row.WithwardRate }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('ManualRechargeRate')" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.RechargeRateEx }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('ManualWithdrawalRate')" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.WithwardRateEx }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="State" :label="$t('Status')"  width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.State == 1">{{$t('Enable')}}</span>
          <span v-else style="color: red">{{$t('deactivate')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="AutoState" :label="$t('AutomaticExchangeRate')"  width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.AutoState == 1">{{$t('Open')}}</span>
          <span v-else style="color: red">{{$t('TurnOff')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UpdateAccount" :label="$t('operator')"  width="70"></el-table-column>
      <el-table-column prop="UpdateTime" width="140" :label="$t('OperatingTime')"></el-table-column>
      <el-table-column  :label="$t('Actions')" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="editRow(scope.row)">{{$t('Edit')}}</el-button>
          <!-- <el-button size="mini" type="danger" @click="deleteRow(scope.row)">{{$t('Delete')}}</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total" @current-change="handleCurrentChange" :page-size="pagesize" :page-sizes="pagesizes" :current-page="current_row"> </el-pagination>
    </div>
    <!-- 编辑/新增 -->
    <addAndEdit v-if="addAndEditData.show" :addAndEditData="addAndEditData" @submitAddAndEditData="submitAddAndEditData" />
    <!-- 基础汇率配置 -->
    <baseExchange v-if="baseExchangeData.show" :baseExchangeData="baseExchangeData" />
    <!-- 变化记录 -->
    <changeHistory v-if="changeHistoryData.show" :changeHistoryData="changeHistoryData" />
    <!-- 批量编辑 -->
    <batchEdit v-if="batchEditData.show" :batchEditData="batchEditData" @saveBatchEditData="saveBatchEditData" />
  </div>
</template>

<script>
import { app } from "@/api/app.js"
import base from "@/api/base.js"
import addAndEdit from "./components/addAndEdit.vue"
import baseExchange from "./components/baseExchange.vue"
import changeHistory from "./components/changeHistory.vue"
import batchEdit from "./components/batchEdit.vue"
export default {
  extends: base,
  name: "finance_symbol",
  components: { addAndEdit, baseExchange, changeHistory, batchEdit },
  data() {
    return {
      queryForm: {
        Symbol: "",
        State: "",
        FType: "",
      },
      tableData: [],
      rowData: {},
      addAndEditData: {
        title: "新增汇率配置",
        show: false,
        data: {},
        baseurl: "",
      },
      baseExchangeData: {
        title: this.$t('BaseExchangeRateConfiguration'),
        show: false,
        data: [],
      },
      changeHistoryData: {
        title: "",
        show: false,
        data: {},
      },
      baseurl: "",
      multipleSelection: [],
      batchEditData: {
        show: false,
        title: "",
        type: "",
      },
    }
  },
  created() {
    this.app = app
    this.getSymbolList()
  },
  methods: {
    // 选择行
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 批量编辑状态
    batchState() {
      if (!this.multipleSelection.length) return this.$message.warning("请选择批量编辑数据")
      this.batchEditData.show = true
      this.batchEditData.title = "状态编辑"
      this.batchEditData.type = 1
    },
    //  批量编辑自动汇率
    batchRate() {
      if (!this.multipleSelection.length) return this.$message.warning("请选择批量编辑数据")
      this.batchEditData.show = true
      this.batchEditData.title = "自动汇率编辑"
      this.batchEditData.type = 2
    },
    // 批量编辑保存
    saveBatchEditData(val) {
      const data = {
        SellerId: this.filters.SellerId,
        Id: this.multipleSelection.map((item) => item.Id),
        Status: +val.State,
        Type: +val.Type,
        GoogleCode: val.GoogleCode,
      }
      app.post("/pay/symbol_update_status", data, (res) => {
        if (res.code == 200) {
          console.log(res)
          this.$message.success(this.$t('EditSuccess'))
          this.batchEditData.show = false
          this.getSymbolList()
        }
      })
    },
    //获取币种
    getSymbolList() {
      const data = {
        SellerId: this.filters.SellerId,
        State: +this.queryForm.State,
        Symbol: this.queryForm.Symbol,
        FType: +this.queryForm.FType,
        Page: this.page,
        PageSize: this.pagesize,
      }
      app.post("/pay/get_symbol_list", data, (res) => {
        if (res.code == 200) {
          this.tableData = res.data.data || []
          this.tableData.forEach((item) => {
            item.UpdateTime = this.$moment(item.UpdateTime).format("YYYY-MM-DD HH:mm:ss")
          })
          this.total = res.data.total
          this.baseurl = res.data.url
        }
      })
    },
    // 变化记录
    showChangeHistory() {
      this.changeHistoryData.show = true
    },
    // 基础汇率配置
    showBaseExchange() {
      this.baseExchangeData.show = true
    },
    // 新增
    addData() {
      this.addAndEditData.title = "新增汇率配置"
      this.addAndEditData.show = true
    },
    // 编辑
    editRow(row) {
      this.addAndEditData.title = "修改汇率配置"
      this.addAndEditData.data = row
      this.addAndEditData.show = true
      this.addAndEditData.baseurl = this.baseurl
    },
    // 新增编辑提交
    submitAddAndEditData(val) {
      const data = {
        SellerId: val.SellerId,
        Symbol: val.Symbol,
        RateSource: val.RateSource,
        RechargeFixType: Number(val.RechargeFixType),
        RechargeFix: Number(val.RechargeFixType == 1) ? Number(val.RechargeFix) : Number(val.RechargeFix) / 100,
        WithwardFixType: Number(val.WithwardFixType),
        WithwardFix: Number(val.WithwardFixType == 1) ? Number(val.WithwardFix) : Number(val.WithwardFix) / 100,
        State: val.State,
        AutoState: val.AutoState,
        Icon: val.Icon,
        Sort: Number(val.Sort),
        GoogleCode: val.GoogleCode,
        RechargeMin: +val.RechargeMin,
        RechargeMax: +val.RechargeMax,
        WithwardMin: +val.WithwardMin,
        WithwardMax: +val.WithwardMax,
        RechargeRateEx: +val.RechargeRateEx,
        WithwardRateEx: +val.WithwardRateEx,
        ShowIndex: +val.ShowIndex,
        NetJson: val.NetJson,
        ColdWallet: val.ColdWallet,
      }
      app.post("/pay/modify_symbol", data, (res) => {
        if (res.code == 200) {
          this.addAndEditData.show = false
          this.$message.success(this.$t('EditSuccess'))
          this.getSymbolList()
        }
      })
    },
    // 删除
    deleteRow(row) {
      app.getGoogleCode((GoogleCode) => {
        // let data = {
        //   SellerId: this.filters.SellerId,
        //   // ChannelId: this.dialog.data.ChannelId,
        //   GroupName: this.dialog.data.GroupName,
        //   GoogleCode: GoogleCode,
        // };
        // app.post("/kefu/add_group", data, (res) => {
        //   if (res.code == 200) {
        //     this.$message({
        //       message: "添加团队成功",
        //       type: "success",
        //     });
        //     this.addTeamVisible = false;
        //     this.getList();
        //   }
        // });
      })
    },
    handleSizeChange(val) {
      this.pagesize = val
      this.getSymbolList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getSymbolList()
    },
  },
}
</script>

<style scoped></style>
